export default (alpha: number) => {
  return Math.round(alpha * 255).toString(16);
};
